export const getEnrollmentLink = (tournamentId: number) => {
  return `${window.location.origin}/tournament/${tournamentId}/enroll`;
};

export const getImageUrl = (url: string) => {
  return url.startsWith('https://turnieje.azurewebsites.net/images/') ? url : 'https://turnieje.azurewebsites.net/images/' + url;
};
